module.exports = "<ng-include src=\"'app/poi/edit/general/partial_descriptions.html'\"></ng-include> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/general/partial_summit.html
// module id = 435
// module chunks = 0